import L from "leaflet";

export default L.icon({
  iconUrl: require("../../../img/icons/position.svg"),
  iconRetinaUrl: require("../../../img/icons/position.svg"),
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [35, 35],
  className: "leaflet-venue-icon",
});
